import React from "react";
import { Button, Form, FormInstance, InputNumber, Select } from "antd";
import {
  GetSharedEwaybillAccountListParams,
  SharedEwaybillShippingAddressStatus,
} from "@/services/api/sharedEwaybillAccount";
import useConsumerEwaybillAccountOptions from "../../hooks/useConsumerEwaybillAccountOptions";

interface SearchFormProps {
  form?: FormInstance<FormValues>;

  onSearch?(): void;

  onReset?(): void;
}

export interface FormValues
  extends Pick<
    GetSharedEwaybillAccountListParams,
    | "consumerName"
    | "ewaybillAccountId"
    | "ewaybillBranchAccountId"
    | "logisticsCompany"
    | "minQuantity"
    | "maxQuantity"
    | "statuses"
  > {}

const SearchForm: React.FC<SearchFormProps> = function (props) {
  const { form: formProps, onReset, onSearch } = props;

  const [form] = Form.useForm<FormValues>(formProps);
  const { loading, ewaybillAccountOptions, getFilterEwaybillBranchAccountOptions, getFilterLogisticsCompanyOptions } =
    useConsumerEwaybillAccountOptions();

  return (
    <Form
      form={form}
      style={{ width: "100%", padding: "24px 12px 0 24px" }}
      initialValues={{
        statuses: [SharedEwaybillShippingAddressStatus.ENABLE, SharedEwaybillShippingAddressStatus.DISABLE],
      }}
    >
      <div style={{ display: "flex" }}>
        <Form.Item name="ewaybillAccountId" label="面单来源账号" style={{ marginRight: 10 }}>
          <Select
            placeholder="全部"
            style={{ width: 156 }}
            options={ewaybillAccountOptions}
            allowClear
            loading={loading}
            showSearch
            dropdownMatchSelectWidth={false}
            optionFilterProp="label"
          ></Select>
        </Form.Item>
        <Form.Item noStyle shouldUpdate={(prev, next) => prev.ewaybillAccountId !== next.ewaybillAccountId}>
          {(form) => {
            const ewaybillAccountId = form.getFieldValue("ewaybillAccountId");

            return (
              <Form.Item name="logisticsCompany" style={{ marginRight: 10 }}>
                <Select
                  placeholder="全部快递"
                  style={{ width: 156 }}
                  allowClear
                  showSearch
                  options={getFilterLogisticsCompanyOptions(ewaybillAccountId)}
                  optionFilterProp="label"
                ></Select>
              </Form.Item>
            );
          }}
        </Form.Item>
        <Form.Item
          noStyle
          shouldUpdate={(prev, next) =>
            prev.ewaybillAccountId !== next.ewaybillAccountId || prev.logisticsCompany !== next.logisticsCompany
          }
        >
          {(form) => {
            const ewaybillAccountId = form.getFieldValue("ewaybillAccountId");
            const logisticsCompany = form.getFieldValue("logisticsCompany");

            return (
              <Form.Item name="ewaybillBranchAccountId" style={{ marginRight: 10 }}>
                <Select
                  placeholder="全部网点"
                  style={{ width: 156 }}
                  allowClear
                  options={getFilterEwaybillBranchAccountOptions(ewaybillAccountId, logisticsCompany)}
                  loading={loading}
                  showSearch
                  dropdownMatchSelectWidth={false}
                  optionFilterProp="label"
                ></Select>
              </Form.Item>
            );
          }}
        </Form.Item>
      </div>

      <div style={{ display: "flex" }}>
        <Form.Item name="statuses" label="状态" style={{ marginLeft: 56, marginRight: 10 }}>
          <Select mode="tags" placeholder="选择状态" style={{ width: 156 }}>
            <Select.Option value={SharedEwaybillShippingAddressStatus.ENABLE}>共享中</Select.Option>
            <Select.Option value={SharedEwaybillShippingAddressStatus.DISABLE}>暂停</Select.Option>
            <Select.Option value={SharedEwaybillShippingAddressStatus.DELETED}>已删除</Select.Option>
          </Select>
        </Form.Item>

        <Form.Item name="minQuantity" style={{ marginRight: 10 }}>
          <InputNumber placeholder="单号余额起" precision={0} style={{ width: 145 }} min={0} />
        </Form.Item>
        <span style={{ lineHeight: "32px" }} className="mr10">
          —
        </span>
        <Form.Item name="maxQuantity" style={{ marginRight: 10 }}>
          <InputNumber placeholder="单号余额止" precision={0} style={{ width: 145 }} min={0} />
        </Form.Item>

        <Button type="primary" onClick={onSearch} className="mr10">
          查询
        </Button>

        <Button onClick={onReset}>重置</Button>
      </div>
    </Form>
  );
};

export default React.memo(SearchForm);
